// extracted by mini-css-extract-plugin
module.exports = {"markdownImage":"Image_markdownImage__1XCjs","fieldImage":"Image_fieldImage__3zTB9"};